/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscribe_To_Read_Full_DescriptionInputs */

const en_subscribe_to_read_full_description = /** @type {(inputs: Subscribe_To_Read_Full_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe to read full description`)
};

const es_subscribe_to_read_full_description = /** @type {(inputs: Subscribe_To_Read_Full_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscríbete para leer la descripción completa`)
};

const fr_subscribe_to_read_full_description = /** @type {(inputs: Subscribe_To_Read_Full_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnez-vous pour lire la description complète`)
};

const de_subscribe_to_read_full_description = /** @type {(inputs: Subscribe_To_Read_Full_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnieren, um die vollständige Beschreibung zu lesen`)
};

const id_subscribe_to_read_full_description = /** @type {(inputs: Subscribe_To_Read_Full_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berlangganan untuk membaca deskripsi lengkap`)
};

/** @type {(inputs: Subscribe_To_Read_Full_DescriptionInputs) => LocalizedString} */
const ja_subscribe_to_read_full_description = en_subscribe_to_read_full_description;

/** @type {(inputs: Subscribe_To_Read_Full_DescriptionInputs) => LocalizedString} */
const zh_subscribe_to_read_full_description = en_subscribe_to_read_full_description;

/** @type {(inputs: Subscribe_To_Read_Full_DescriptionInputs) => LocalizedString} */
const ar_subscribe_to_read_full_description = en_subscribe_to_read_full_description;

/** @type {(inputs: Subscribe_To_Read_Full_DescriptionInputs) => LocalizedString} */
const it_subscribe_to_read_full_description = en_subscribe_to_read_full_description;

/** @type {(inputs: Subscribe_To_Read_Full_DescriptionInputs) => LocalizedString} */
const ru_subscribe_to_read_full_description = en_subscribe_to_read_full_description;

/** @type {(inputs: Subscribe_To_Read_Full_DescriptionInputs) => LocalizedString} */
const pt_subscribe_to_read_full_description = en_subscribe_to_read_full_description;

/** @type {(inputs: Subscribe_To_Read_Full_DescriptionInputs) => LocalizedString} */
const ko_subscribe_to_read_full_description = en_subscribe_to_read_full_description;

/**
* | output |
* | --- |
* | "Subscribe to read full description" |
*
* @param {Subscribe_To_Read_Full_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const subscribe_to_read_full_description = /** @type {((inputs?: Subscribe_To_Read_Full_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscribe_To_Read_Full_DescriptionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscribe_to_read_full_description(inputs)
	if (locale === "es") return es_subscribe_to_read_full_description(inputs)
	if (locale === "fr") return fr_subscribe_to_read_full_description(inputs)
	if (locale === "de") return de_subscribe_to_read_full_description(inputs)
	if (locale === "ja") return ja_subscribe_to_read_full_description(inputs)
	if (locale === "zh") return zh_subscribe_to_read_full_description(inputs)
	if (locale === "ar") return ar_subscribe_to_read_full_description(inputs)
	if (locale === "id") return id_subscribe_to_read_full_description(inputs)
	if (locale === "it") return it_subscribe_to_read_full_description(inputs)
	if (locale === "ru") return ru_subscribe_to_read_full_description(inputs)
	if (locale === "pt") return pt_subscribe_to_read_full_description(inputs)
	return ko_subscribe_to_read_full_description(inputs)
});